import React, { useContext } from "react";
import AppRoutes from "./Routes";
import ThemeWrapper from "./ThemeWrapper";
import { CookieProvider } from "./Context/CookieContext";
import { AppProvider, AppContext } from "./Context/AppContext";
import { SocketProvider } from "./Context/SocketContext/SocketProvider";
import "./global.scss";
import AppLoader from "./Components/AppLoader";
import { Box, Typography } from "@mui/material";

const AppContent = () => {
  const { isLoading, systemError } = useContext(AppContext);

  if (isLoading) {
    return <AppLoader />;
  }

  if (systemError) {
    return (
      <Box
        sx={{
          textAlign: "center",
          padding: "60px",
          color: "rgba(47, 43, 61, 1)",
          fontSize: "16px",
          fontWeight: 500,
        }}
      >
        <Typography variant="h6">{systemError}</Typography>
        <Typography variant="body1">
          Please try again later or contact support
        </Typography>
      </Box>
    );
  }

  return (
    <ThemeWrapper>
      <AppRoutes />
    </ThemeWrapper>
  );
};

function App() {
  return (
    <CookieProvider>
      <AppProvider>
        <SocketProvider>
          <AppContent />
        </SocketProvider>
      </AppProvider>
    </CookieProvider>
  );
}

export default App;
